/**
 * Ocean Infinity - Footer Section
 *
 * Modern footer design with ocean wave SVG
 * Newsletter subscription and maritime theme
 * Ocean Infinity Deep Blue Theme
 */

import { useEffect } from "react";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import "../styles/components/Footer.css";

const Footer = () => {
  useEffect(() => {
    // Temporarily disable custom font loading due to file corruption
    // Use fallback font instead
    const headline = document.querySelector(".footer-headline");
    if (headline) {
      headline.classList.add("font-loaded");
    }
  }, []);

  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Top Section - Main Content */}
        <div className="footer-main">
          {/* Company Branding */}
          <div className="footer-brand">
            <div className="footer-logo">
              <img
                src="/logo.webp"
                alt="Ocean Infinity"
                className="footer-logo-image footer-logo-first"
              />
            </div>
            <p className="footer-description">
              Specialized marine service provider delivering high-quality
              solutions for ship owners and management companies across all UAE
              ports.
            </p>
            <p className="footer-headline">
              &quot;Delivering Expectations for Every Voyage&quot;
            </p>
            <div className="footer-social">
              <a
                href="https://www.facebook.com/oceaninfinitymarine/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/company/ocean-infinity-marine-services-llc/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Links Section */}
          <div className="footer-links-section">
            {/* Quick Links */}
            <div className="footer-links-group">
              <h4 className="footer-links-title">Quick Links</h4>
              <nav className="footer-nav">
                <a href="/about" className="footer-link">
                  About Us
                </a>
                <a href="/services" className="footer-link">
                  Services
                </a>
                <a href="/careers" className="footer-link">
                  Careers
                </a>
                <a href="/contact" className="footer-link">
                  Contact
                </a>
              </nav>
            </div>

            {/* Group Companies */}
            <div className="footer-links-group">
              <h4 className="footer-links-title">Group Companies</h4>
              <div className="footer-companies">
                <span>Ocean Serenity FZ-LLC</span>
                <span>Ocean Infinity Marine Service</span>
                <span>Warmsol Marine & Industrial</span>
                <span>ANC Arabia Contracting</span>
                <span>Knot & Sail</span>
              </div>
            </div>
            {/* Contact */}
            <div className="footer-links-group">
              <h4 className="footer-links-title">Contact</h4>
              <div className="footer-contact-info">
                <address>
                  Xavier Business Center
                  <br />
                  Office Suite No: A5 - 18
                  <br />
                  Dubai - UAE
                </address>
                <div className="footer-contact-details">
                  <a href="tel:+971527756765" className="footer-contact-link">
                    +971 527756765
                  </a>
                  {/* <a href="tel:+971581464580" className="footer-contact-link">
                    +971 58 146 4580
                  </a> */}
                  <a
                    href="mailto:info@oceaninfinitymarine.com"
                    className="footer-contact-link"
                  >
                    info@oceaninfinitymarine.com
                  </a>
                  {/* <a
                    href="mailto:operation@knotandsail.com"
                    className="footer-contact-link"
                  >
                    operation@knotandsail.com
                  </a> */}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section - Copyright & Social */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="copyright">
              Copyright © Ocean Infinity | Designed by{" "}
              <a
                href="https://tarah.ae/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-design-link"
              >
                tarah.ae
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
